import { Serializer } from 'jsonapi-serializer'

type SerializedData<T> = Readonly<{
  data: {
    type: string
    id?: number
    attributes: T
  }
}>

export function serializeJSONApiData<T extends Record<string, any>>(
  key: string,
  data: T,
  noId = false
): SerializedData<T> {
  const keyedSerializer = new Serializer(key, {
    attributes: Object.keys(data),
    keyForAttribute: 'underscore_case',
  })
  const serializedData = keyedSerializer.serialize(data)
  if (noId) {
    delete serializedData.data.id
  }
  return serializedData
}

export default serializeJSONApiData
